import urlsService, { Target } from '@/services/urls-service';
import { baseApi } from './baseApi';

export interface ILoginRequest {
  username: string;
  password: string;
}

export interface ILoginResponse {
  token: string;
  redirectUrl: string;
}

interface IResetPasswordRequest {
  usernameOrEmail: string;
}

export interface IChangePasswordByTokenRequest {
  username: string;
  token: string;
  password: string;
}

export interface IValidatePasswordTokenRequest {
  token: string;
  userId: string;
}

export interface IValidatePasswordTokenResponse {
  name: string;
  valid: boolean;
}

export const userApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    authenticateUser: builder.mutation<ILoginResponse, ILoginRequest>({
      query: (loginRequest) => ({
        url: urlsService.getUrl('/clapi/security/login', { target: Target.Sitecore }),
        method: 'POST',
        body: loginRequest
      })
    }),
    resetPassword: builder.mutation<any, IResetPasswordRequest>({
      query(req: IResetPasswordRequest) {
        return {
          url: urlsService.getUrl('/users/resetpassword'),
          method: 'POST',
          body: req
        };
      }
    }),
    changePasswordByToken: builder.mutation<any, IChangePasswordByTokenRequest>({
      query(req: IChangePasswordByTokenRequest) {
        return {
          url: urlsService.getUrl('/users/changepasswordbytoken'),
          method: 'POST',
          body: req
        };
      }
    }),
    validatePasswordToken: builder.mutation<IValidatePasswordTokenResponse, IValidatePasswordTokenRequest>({
      query(req: IValidatePasswordTokenRequest) {
        return {
          url: urlsService.getUrl('/users/validatePasswordToken'),
          method: 'POST',
          body: req
        };
      }
    })
  })
});

export const { useAuthenticateUserMutation, useResetPasswordMutation, useChangePasswordByTokenMutation, useValidatePasswordTokenMutation } =
  userApi;
